/**
 * Action types for the Preschool Curriculum admin slice (Phase 5).
 *
 * Mirrors the spaceEntity type shape: one fetch action per entity,
 * one shared UPDATE_PRESCHOOL_DATA across all entities (the saga's
 * mapping table dispatches to the right API call by entity name).
 */
export const FETCH_PRESCHOOL_SKILL_DATA = 'FETCH_PRESCHOOL_SKILL_DATA'
export const FETCH_PRESCHOOL_SKILL_DATA_SUCCESS =
  'FETCH_PRESCHOOL_SKILL_DATA_SUCCESS'

export const FETCH_PRESCHOOL_WEEKLY_THEME_DATA =
  'FETCH_PRESCHOOL_WEEKLY_THEME_DATA'
export const FETCH_PRESCHOOL_WEEKLY_THEME_DATA_SUCCESS =
  'FETCH_PRESCHOOL_WEEKLY_THEME_DATA_SUCCESS'

export const FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA =
  'FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA'
export const FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA_SUCCESS =
  'FETCH_PRESCHOOL_WEEKLY_SKILL_PLAN_DATA_SUCCESS'

export const FETCH_PRESCHOOL_MONTHLY_THEME_DATA =
  'FETCH_PRESCHOOL_MONTHLY_THEME_DATA'
export const FETCH_PRESCHOOL_MONTHLY_THEME_DATA_SUCCESS =
  'FETCH_PRESCHOOL_MONTHLY_THEME_DATA_SUCCESS'

export const FETCH_PRESCHOOL_ANNUAL_LO_DATA = 'FETCH_PRESCHOOL_ANNUAL_LO_DATA'
export const FETCH_PRESCHOOL_ANNUAL_LO_DATA_SUCCESS =
  'FETCH_PRESCHOOL_ANNUAL_LO_DATA_SUCCESS'

export const FETCH_PRESCHOOL_SPIRAL_LO_DATA = 'FETCH_PRESCHOOL_SPIRAL_LO_DATA'
export const FETCH_PRESCHOOL_SPIRAL_LO_DATA_SUCCESS =
  'FETCH_PRESCHOOL_SPIRAL_LO_DATA_SUCCESS'

export const UPDATE_PRESCHOOL_DATA = 'UPDATE_PRESCHOOL_DATA'
export const UPDATE_PRESCHOOL_DATA_SUCCESS = 'UPDATE_PRESCHOOL_DATA_SUCCESS'
